module.exports = __webpack_public_path__ + "static/img/appstore.aeb0a0fa.png";